/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="134.81"
        height="82.27"
        viewBox="0 0 134.81 82.27"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M118.56 29.74a1 1 0 0 1 1.95.43v.11l-3.32 11.83a1.023 1.023 0 0 1-2-.43v-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M94.47 35.73a1.25 1.25 0 0 1 1.42-.89h.12l20.53 5.76a1.26 1.26 0 0 1 .86 1.55 1.24 1.24 0 0 1-1.41.89h-.13l-20.52-5.76a1.26 1.26 0 0 1-.87-1.55ZM17 .01H17.46L47.3 8.43a1.25 1.25 0 0 1-.55 2.44h-.13L17 2.5 3.81 3.89l10.54 8 30.47 8.61a1.26 1.26 0 0 1 .9 1.42v.12a1.25 1.25 0 0 1-1.42.9h-.12l-30.7-8.62a1.08 1.08 0 0 1-.29-.13l-.19-.12L.7 4.69l-.08-.07a1.67 1.67 0 0 1 .69-3h.26ZM97 23.67a1.25 1.25 0 0 1 1.42-.89h.12l21.37 6a1.25 1.25 0 0 1-.55 2.44h-.13l-21.37-6a1.26 1.26 0 0 1-.86-1.55Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M118.32 29.68a1.24 1.24 0 0 1 1.41-.9h.13l12.55 3.52a3.33 3.33 0 0 1 2.33 3.89l-.05.18-2.21 7.88a3.31 3.31 0 0 1-3.89 2.33h-.18l-12.55-3.52a1.25 1.25 0 0 1 .55-2.43h.13l12.55 3.53a.8.8 0 0 0 .94-.45v-.1l2.21-7.89a.79.79 0 0 0-.45-.94h-.1l-12.55-3.52a1.25 1.25 0 0 1-.82-1.58Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="m84.35 19.08-3.66 17.83a7.881 7.881 0 0 0 15.44 3.17l3.66-17.83A7.89 7.89 0 0 0 93.9 13l-.24-.06a7.91 7.91 0 0 0-9.31 6.14Zm8.8-3.69a5.4 5.4 0 0 1 4.19 6.35l-3.66 17.83a5.38 5.38 0 0 1-10.54-2.16l3.66-17.83a5.41 5.41 0 0 1 6.14-4.23Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="m72 13.22-4.32 21a7.881 7.881 0 0 0 15.44 3.17l4.32-21a7.9 7.9 0 0 0-5.89-9.25h-.25a7.9 7.9 0 0 0-9.3 6.08Zm8.82-3.72A5.39 5.39 0 0 1 85 15.89l-4.32 21a5.38 5.38 0 0 1-10.54-2.17l4.32-21a5.39 5.39 0 0 1 6.36-4.22Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M46.11 7.59a7.87 7.87 0 0 1 14.75-2v.07l.1-.13a7.9 7.9 0 0 1 7.41-2.74h.24a7.9 7.9 0 0 1 6.18 9.06v.25l-4.64 22.64a1.25 1.25 0 0 1-2.47-.37v-.13l4.64-22.56A5.38 5.38 0 0 0 61.85 9.3v.22l-4.31 20.74a1.25 1.25 0 0 1-2.47-.36v-.14l4-19.51a5.383 5.383 0 0 0-10.5-2.38v.22L45 25.23a1.25 1.25 0 0 1-2.47-.38v-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M16.14.98a1 1 0 0 1 1.95.43v.11l-3.34 11.82a1 1 0 0 1-1.95-.42v-.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M94.63 38.99A1.24 1.24 0 0 1 96 40.05a31.16 31.16 0 0 1-.38 10.72C94.26 57.4 91 63.15 86.77 66.59l-.32.25-.44 14.22a1.25 1.25 0 0 1-2.49 0v-.13l.44-14.2v-.38a2.47 2.47 0 0 1 .92-1.48c3.89-3 7-8.35 8.25-14.59a28.69 28.69 0 0 0 .36-9.86 1.25 1.25 0 0 1 1.14-1.43ZM67.62 34.65a1.25 1.25 0 1 1 2.45.5 7.9 7.9 0 0 1-4.61 5.65 1.254 1.254 0 1 1-1-2.3 5.38 5.38 0 0 0 3.16-3.85Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M42.47 24.91a7.82 7.82 0 0 1 10.71 0l.24.23 7.2 7.61 2.94 3.15 1.12 1.23.43.5.07.08A8.12 8.12 0 0 1 67 44.43a8.54 8.54 0 0 1-3.07 4.77l-.25.19c-2.68 2.11-6.26 2.16-10.31-.7l-.28-.2-7.45-5.48A1.25 1.25 0 0 1 47 40.92l.12.07 7.45 5.51c3.18 2.35 5.55 2.41 7.46 1l.17-.13a6 6 0 0 0 2.37-3.49 5.48 5.48 0 0 0-1.19-4.38l-.21-.28-.17-.21-.65-.72-1.51-1.64-4.67-5-4.55-4.75-.19-.19a5.3 5.3 0 0 0-2.28-1.21l-.26-.06a5.36 5.36 0 0 0-4.51 1.14l-.19.17-11.72 11.23a5.56 5.56 0 0 0-.31 7.67l9.19 10.07a17.77 17.77 0 0 1 4.32 11.61v.44l-.32 13.28a1.25 1.25 0 0 1-2.5.07v-.13l.32-13.28a15.26 15.26 0 0 0-3.42-10l-.26-.3-8.99-9.91a8 8 0 0 1 0-11.17l.19-.19Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FistHoldingPencilIcon';

export default Icon;
